<template>
  <div class="container mt-2 px-2">
    <div class="card shadow p-4">
      <h3 class="mb-4">Movimientos de Inventario - Hotel</h3>

      <!-- ✅ Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- 🧾 Formulario -->
      <div class="border rounded p-3 mb-4 bg-light">
        <h5 class="mb-3">Registrar Movimiento</h5>

        <div class="row g-3 align-items-end">
          <!-- 🔍 Buscador -->
          <div class="col-md-4">
            <label class="form-label">Buscar producto</label>
            <input
              v-model="busquedaProducto"
              type="text"
              class="form-control"
              placeholder="Escribe para filtrar productos..."
            />
          </div>

          <!-- Select filtrado -->
          <div class="col-md-4">
            <label class="form-label">Producto</label>
            <select v-model="form.IdProductoHotel" class="form-select">
              <option disabled value="">Seleccione producto</option>
              <option
                v-for="p in productosFiltrados"
                :key="p.IdProductoHotel"
                :value="p.IdProductoHotel"
              >
                {{ p.NombreProducto }}
              </option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Cantidad</label>
            <input
              v-model.number="form.Cantidad"
              type="number"
              min="1"
              class="form-control"
              placeholder="Cantidad"
            />
          </div>

          <div class="col-md-2">
            <label class="form-label">Destino</label>
            <select v-model="form.Destino" class="form-select">
              <option disabled value="">Destino</option>
              <option :value="0">Lavandería</option>
              <option :value="1">Recepción</option>
            </select>
          </div>

          <div class="col-12 col-md-2 d-grid">
            <button class="btn btn-success" @click="registrarMovimiento">Registrar</button>
          </div>
        </div>
      </div>

      <!-- 📋 Tabla de movimientos -->
      <div>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="m-0">Historial de Movimientos</h5>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered text-center align-middle">
            <thead class="table-light">
              <tr>
                <th>Fecha</th>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Destino</th>
                <th>Empleado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="movimientos.length === 0">
                <td colspan="6">No hay movimientos registrados.</td>
              </tr>
              <tr v-for="m in movimientos" :key="m.IdMovimientoInventarioHotel">
                <td>{{ formatearFecha(m.FechaMovimiento) }}</td>
                <td>{{ m.producto?.NombreProducto || '-' }}</td>
                <td>{{ m.Cantidad }}</td>
                <td>{{ Number(m.Destino) === 0 ? 'Lavandería' : 'Recepción' }}</td>
                <td>{{ m.empleado ? (m.empleado.Nombres + ' ' + m.empleado.Apellidos) : '-' }}</td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    v-if="Number(m.Cantidad) > 0"
                    @click="abrirModalReversion(m)"
                  >
                    Revertir movimiento
                  </button>
                  <span v-else class="badge bg-secondary">Revertido</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ⚠️ Mini Modal de Confirmación -->
    <div v-if="mostrarModalReversion" class="modal-backdrop" @click.self="cerrarModalReversion">
      <div class="modal-content small" @click.stop>
        <div class="modal-header">
          <h6 class="modal-title text-danger">Confirmar reversión</h6>
          <button type="button" class="btn-close" @click="cerrarModalReversion"></button>
        </div>
        <div class="modal-body">
          <p class="mb-1"><strong>Producto:</strong> {{ movimientoSeleccionado?.producto?.NombreProducto || '-' }}</p>
          <p class="mb-1"><strong>Destino:</strong> {{ Number(movimientoSeleccionado?.Destino) === 0 ? 'Lavandería' : 'Recepción' }}</p>
          <p class="mb-0"><strong>Cantidad a revertir:</strong> {{ movimientoSeleccionado?.Cantidad }}</p>
        </div>
        <div class="modal-footer d-flex justify-content-center gap-2">
          <button class="btn btn-secondary btn-sm" @click="cerrarModalReversion">Cancelar</button>
          <button class="btn btn-danger btn-sm" @click="confirmarReversion">Revertir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config";
import store from "@/store";

export default {
  name: "MovimientoInventariosHotel",
  data() {
    return {
      productos: [],
      movimientos: [],
      form: {
        IdProductoHotel: "",
        Cantidad: null,
        Destino: ""
      },
      busquedaProducto: "",
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },

      // Modal reversión
      mostrarModalReversion: false,
      movimientoSeleccionado: null
    };
  },
  computed: {
    empleadoId() {
      return store.getters.getUser?.IdEmpleado || null;
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    productosFiltrados() {
      const q = (this.busquedaProducto || "").toLowerCase().trim();
      if (!q) return this.productos;
      return this.productos.filter(p =>
        (p.NombreProducto || "").toLowerCase().includes(q)
      );
    }
  },
  methods: {
    // 🔁 Reversión
    abrirModalReversion(mov) {
      this.movimientoSeleccionado = mov;
      this.mostrarModalReversion = true;
    },
    cerrarModalReversion() {
      this.mostrarModalReversion = false;
      this.movimientoSeleccionado = null;
    },
    async confirmarReversion() {
      if (!this.movimientoSeleccionado) return;
      try {
        const id = this.movimientoSeleccionado.IdMovimientoInventariosHotel;
        const { data } = await axios.post(`${API_URL}/movimientos-hotel/${id}/revertir`);
        this.mostrarAlerta(data.message || "Reversión aplicada");
        this.cerrarModalReversion();
        this.cargarMovimientos();
        this.cargarProductos();
      } catch (error) {
        const msg = error.response?.data?.message || "No se pudo revertir";
        this.mostrarAlerta(msg, "danger");
      }
    },

    // ⚙️ Toast
    cerrarToast() { this.mostrarToast = false; },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },

    // 🗓 Fecha
    formatearFecha(f) {
      try { return new Date(f).toLocaleString("es-GT"); } catch { return f; }
    },

    // 🚀 Cargas iniciales
    async cargarMovimientos() {
      try {
        const { data } = await axios.get(`${API_URL}/movimientos-inventarios-hotel`);
        this.movimientos = data;
      } catch {
        this.mostrarAlerta("Error al cargar movimientos", "danger");
      }
    },
    async cargarProductos() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-general-hotel`);
        this.productos = data;
      } catch {
        this.mostrarAlerta("Error al cargar productos", "danger");
      }
    },

    // 📝 Registrar movimiento
    async registrarMovimiento() {
      if (!this.form.IdProductoHotel || !this.form.Cantidad || this.form.Destino === "") {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      if (!this.empleadoId) {
        this.mostrarAlerta("No se encontró el empleado logueado", "danger");
        return;
      }

      try {
        const payload = { ...this.form, IdEmpleado: this.empleadoId };
        const { data } = await axios.post(`${API_URL}/movimientos-inventarios-hotel`, payload);
        this.mostrarAlerta(data.message || "Movimiento registrado");
        this.cargarMovimientos();
        this.form = { IdProductoHotel: "", Cantidad: null, Destino: "" };
        this.busquedaProducto = "";
      } catch (error) {
        const msg = error.response?.data?.message || "Error al registrar movimiento";
        this.mostrarAlerta(msg, "danger");
      }
    }
  },
  mounted() {
    this.cargarMovimientos();
    this.cargarProductos();
  }
};
</script>

<style scoped>
/* ✅ Mini modal */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 420px;
  padding: 18px 18px 14px;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0,0,0,.25);
  z-index: 5001;
}
.modal-content.small { width: 420px; }
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: .25rem;
  border-bottom: 1px solid #eee;
}
.modal-body { padding: .75rem 0; }
.modal-footer { padding-top: .75rem; border-top: 1px solid #eee; }
</style>
